import { AbstractControl, FormControl } from '@angular/forms';
import { Observable, concat, defer, of } from 'rxjs';

export function formControlValue$<T = any>(
  control: FormControl | AbstractControl,
): Observable<T | undefined> {
  return concat(
    defer(() => of(control.value)),
    control.valueChanges,
  );
}
